import { Paper } from '@mui/material';
import { Box } from '@mui/system';
import { useNavigate } from 'react-router-dom';

import Login from '~/containers/Login';

function LoginPage() {
  const navigate = useNavigate();
  return (
    <Box ml={2} mr={2}>
      <Paper elevation={3} style={{ padding: '15px 0', borderRadius: 20, maxWidth: 450, margin: '100px auto' }}>
        <Login
          onForgotPasswordClicked={() => {
            navigate('/forgot-password');
          }}
          onSignUpClicked={() => {
            navigate('/register');
          }}
        />
      </Paper>
    </Box>
  );
}

export default LoginPage;
